import React from 'react';

/*
    This context provides the bool of whether to show errors on untouched inputs or not
    to consumers such as ssm-field-wrapper. This allows the bool to be passed to the consumer
    directly without being passed down layers of parents as a prop
*/
const ShowUnTouchedErrorscontext = React.createContext({});
export const ShowUnTouchedProvider = ShowUnTouchedErrorscontext.Provider;
export const ShowUnTouchedConsumer = ShowUnTouchedErrorscontext.Consumer;
